import { BizzCommonService } from './bizz-common.service';
import { BaseService } from '../../_services/base.service';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomerDetailHTTPResponse, DashboardCustomerListResponse, DashboardSaleSummaryResponse } from 'src/app/_models/internal-management-dashboard/dashboard/DashboardSaleSummary';

@Injectable({
  providedIn: 'root',
})
export class BizzCustomersService {
  activeItem: any = '';

  constructor(
    private _bs: BaseService,
    private _bizzCommonService: BizzCommonService
  ) { }

  // Maps the app's environment to the value the API expects.
  // localhost / devadmin.lincsell.com -> dev -> development; ?env=dev and ?env=stg also accepted.
  // No env (or any other value) -> production.
  private resolveEnvironmentParam(): string {
    const host = window.location.hostname.toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1' || host === 'devadmin.lincsell.com') return 'dev';
    const fromHash = window.location.hash.includes('?') ? window.location.hash.split('?')[1] : '';
    const env = (new URLSearchParams(window.location.search).get('env') ?? new URLSearchParams(fromHash).get('env') ?? '').toLowerCase();
    if (env === 'dev') return 'dev';
    if (env === 'stg') return 'staging';
    return 'production';
  }

  getAllCustomers(pageno: any, pagesize: any, filterValue: any) {
    // const  url = 'https://connect360.azure-api.net/account-svc/api/'+ `GetBusinessCustomers?pageNo=${pageno}&pageSize=${pagesize}&filterValue=${filterValue}`;
    const url =
      environment.BusinessBaseURL +
      `GetBusinessCustomers?pageNo=${pageno}&pageSize=${pagesize}&filterValue=${filterValue}&env=${this.resolveEnvironmentParam()}`;
    const header = this._bizzCommonService.makeHttpHeader();
    return this._bs.httpGet(url).pipe(
      map((res) => {
        return res;
      })
    );
  }
  updateBusinessStatus(CustomerId, Status, Reason: string | null = null) {
    let url =
      environment.BusinessBaseURL +
      `UpdateBusinessStatus/${CustomerId}/${Status}`;
    return this._bs.httpPut(url, { Reason }).pipe(
      map((res) => {
        return res;
      })
    );
  }

  saveCustomerCurrencyPreference(payload: any) {
    const url =
      environment.BusinessBaseURL +
      environment.SetBusinessCurrency;
    return this._bs.httpPost(url, payload).pipe(
      map((res) => {
        return res;
      })
    );
  }

  private getReport<T>(request: object): Observable<T> {
    const url = `${environment.BusinessBaseURL}GetReport`;
    const header = this._bizzCommonService.makeHttpHeader(); // Assuming this is still needed for headers

    return this._bs.httpPost(url, request).pipe(
      map((res: T) => {
        return res;
      }),
      catchError((error) => {
        console.error('Error fetching report:', error);
        // Re-throw the error to be handled by the subscriber in the component
        return throwError(() => new Error('Failed to load report. Please try again later.'));
      })
    );
  }

  getDashboardSummary(
    request: object
  ): Observable<DashboardSaleSummaryResponse> {
     return this.getReport<DashboardSaleSummaryResponse>(request);
  }

  getDashboardCustomerListV2(
    request: object
  ): Observable<DashboardSaleSummaryResponse> {
   
     return this.getReport<DashboardSaleSummaryResponse>(request);
  }

  editBusinessPlan(request: object): Observable<any> {
    const url = `${environment.BusinessBaseURL}businessplan/edit`;
    return this._bs.httpPost(url, request).pipe(
      map((res) => {
        return res;
      })
    );
  }

   getCustomerDetail(
    request: object
  ): Observable<CustomerDetailHTTPResponse> {
    const url = `${environment.BusinessBaseURL}GetReport`;

    return this._bs.httpPost(
      url,
      request,
      false,
      true,
      null,
      true
    ).pipe(
      map((res: CustomerDetailHTTPResponse) => {
        return res;
      }),
      catchError((error) => {
        console.error('Error fetching customer detail report:', error);
        return throwError(() => new Error('Failed to load report. Please try again later.'));
      })
    );
  }
}
